import FormFieldAPI from './form_field_api';

/**
 * @class AutocompleteFormFieldAPI
 * @extends FormFieldAPI
 */
class AutocompleteFormFieldAPI extends FormFieldAPI {
	/**
	 * @constructor
	 * @param {*} param0
	 */
	constructor({ id, storeId, formId, gridId, applyMode, isGridField = false }) {
		super({ id, storeId, formId, gridId, applyMode, isGridField });
	}

	/**
	 *
	 */
	clear() {
		return this.set({ options: [], value: [] });
	}

	value(val) {
		if(typeof val !== 'undefined') {
			if (Array.isArray(val))
				return super.value(val);
			else {
				let valCopy = val ? [val] : [];
				return super.value(valCopy);
			}
		}

		return super.value(val)
	}

	/**
	 *
	 * @param {*} options
	 * @param {*} overrite
	 */
	addOptions(options, overrite = false, maintainValue = false) {
		const newOptions = this._parseOptions(options);

		if (typeof overrite !== "undefined" && overrite === true) {
			if (maintainValue) {
				return this.set({ options: newOptions });
			}
			else {
				return this.set({ options: newOptions, value: [] });
			}
		}

		const oldOptions = this.options() || [];

		return this.set({ options: oldOptions.concat( this.filterExistingOptions(oldOptions, newOptions) ) });
	}

	filterExistingOptions(oldOptions, newOptions) {
		return newOptions.filter(newOption => !oldOptions.map(oldOption => oldOption.name).includes(newOption.name) )
	}

	/**
	 *
	 * @param {*} optionIds
	 */
	removeOptions(optionIds) {
		optionIds = this._ensureIsArray(optionIds);

		if (!optionIds.length)
			return this.set({ options: [], value: [] });

		var filteredOptions = this.options().slice().filter((option) => this._filterOptionsToRemove(option, optionIds));
		var filteredValue = this._filterValueAfterOptionRemoval(filteredOptions);

		return this.set({ options: filteredOptions, value: filteredValue });
	}

	/**
	 * @private
	 * @param {*} options
	 */
	_parseOptions(options) {
		var parsedOptions = this._ensureIsArray(options);

		if (typeof parsedOptions[0] !== 'object') {
			return parsedOptions.map(o => ({ value: o, name: o }));
		}
		return parsedOptions;
	}

	/**
	 * @private
	 * @param {*} value
	 */
	_ensureIsArray(value) {
		if (value === undefined || value === null) return [];
		if (!Array.isArray(value)) value = [value];
		return value;
	}

	/**
	 * @private
	 * @param {*} option
	 * @param {*} optionIds
	 */
	_filterOptionsToRemove(option, optionIds) {
		return !(optionIds.includes(option.value.trim()) || optionIds.includes(option.name.trim()));
	}

	/**
	 * @private
	 * @param {*} filteredOptions
	 */
	_filterValueAfterOptionRemoval(filteredOptions) {
		var fieldValues = this._ensureIsArray(this.value());
		return fieldValues.slice().filter((value) => {
			return filteredOptions.map(o => o.value).includes(value);
		});
	}
}

export default AutocompleteFormFieldAPI;
